import { NoResultsMessage } from '@wix/cc-user-facing-common-components';
import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';

import { SearchBadge } from '../../Header/HeaderRight/SearchBarModal/SearchBarModalBody/SearchBadge';
import { pushUrl } from '../../InnerLink';
import { BADGES } from '../../KnowledgeAgentSearchHero';
import { SearchInput } from '../SearchInput';

import css from './index.module.scss';

type NoResultsFoundV2Props = {
  onSearch: (newTerm: string) => void;
  initialSearchTerm?: string;
};

const NoResultsFoundV2 = ({ onSearch, initialSearchTerm }: NoResultsFoundV2Props) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const handleBackClick = () => {
    void pushUrl('/', false, locale as string);
  };

  return (
    <Box className={css.wrapper}>
      <Box className={css.card} direction="vertical">
        <Box direction="vertical" gap="SP2" className={css.cardContentTop}>
          <SearchInput
            initialSearchTerm={initialSearchTerm}
            onSearch={onSearch}
            retryGenerateAnswer={() => onSearch(initialSearchTerm || '')}
            hideGradient />
          <Box className={css.badges}>
            {BADGES.map((badge) => (
              <SearchBadge
                key={badge.key}
                badge={badge}
                onClick={() =>
                  onSearch(t(badge.key))
                }
              />
            ))}
          </Box>
        </Box>
        <NoResultsMessage
          locale={locale as string}
          searchTerm={initialSearchTerm}
          onBackClick={handleBackClick}
        />
      </Box>
    </Box>
  );
};

export default NoResultsFoundV2;
